import { Button, Spinner } from "@garther/ui/components";
import { useI18n } from "@garther/ui/libs";

interface QuizNavigationProps {
  currentQuestion: number;
  totalQuestions: number;
  canProceed: () => boolean;
  isSubmitting: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export default function QuizNavigation({
  currentQuestion,
  totalQuestions,
  canProceed,
  isSubmitting,
  onPrevious,
  onNext,
  onSubmit
}: QuizNavigationProps) {
  const { t } = useI18n();

  const isLastQuestion = currentQuestion === totalQuestions - 1;

  return (
    <div className="flex justify-between items-center pt-8 border-t border-border">
      <Button variant="outline" onClick={onPrevious} disabled={currentQuestion === 0}>
        ← {t("quiz.navigation.previous")}
      </Button>

      <div className="flex space-x-4">
        {!isLastQuestion ? (
          <Button variant="default" onClick={onNext} disabled={!canProceed()}>
            {t("quiz.navigation.next")} →
          </Button>
        ) : (
          <Button variant="default" onClick={onSubmit} disabled={!canProceed() || isSubmitting}>
            {isSubmitting ? (
              <div className="flex items-center space-x-3">
                <Spinner className="w-5 h-5" />
                <span>{t("quiz.page.submitting")}</span>
              </div>
            ) : (
              t("quiz.navigation.submit")
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
